import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import authService from '../services/authService';

export const useUserQuery = (options = {}) => {
  return useQuery({
    queryKey: ['user'],
    queryFn: () => authService.getAccount(),
    ...options,
  });
};

export const useLoginMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ email, password, rememberMe }) =>
      authService.login(email, password, rememberMe),

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['user'] });
    },
  });
};

export const useAdminLoginMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ email, password, rememberMe }) =>
      authService.adminLogin(email, password, rememberMe),

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['user'] });
    },
  });
};

export const useSignupMutation = () => {
  return useMutation({
    mutationFn: (userData) => authService.signup(userData),
  });
};

export const useUpdateAccountMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (accountData) => authService.updateAccount(accountData),

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['user'] });
    },
  });
};

export const useChangePasswordMutation = () => {
  return useMutation({
    mutationFn: ({ currentPassword, newPassword }) =>
      authService.changePassword(currentPassword, newPassword),
  });
};
